const playerImages = {
  "109589": "https://image.khrono.no/807308.webp?imageId=807308&width=706&height=404&format=webp",
  "112128": "https://haugesund-toppidrettsgymnas.no/wp-content/uploads/2019/11/C1Q6653.jpg",
  "104937": "/danila.jpg",
  "111201": "https://i.imgur.com/G66wtrV.png",
  "102606": "https://gojysk.com/sites/default/files/inline-images/424-1_1.png",
  "116168": "https://i.imgur.com/chGzwBL.jpeg"
   // Adjusted path to reference the image in the public directory
  // Add more player images as needed
  // Format: "playerId": "imageUrl"
};

export default playerImages;
